import { isEmpty, isString } from 'lodash';
import { BUYER_TYPES, BUYER_DOCUMENTS_ATTRIBUTES, BUYER_REPRESENTATIVE_DOCS_ATTRIBUTES } from './constants';

function useBuyerDetailsActions() {
  const getBuyerType = buyer => {
    if (isEmpty(buyer)) return null;
    const tradeLicense = buyer?.tradeLicenseNo || buyer?.tradeLicenseNumber || buyer?.licenseNumber;
    if (isString(tradeLicense) && !isEmpty(tradeLicense) && buyer?.government) return BUYER_TYPES.GOVERNMENT;
    if (isString(tradeLicense) && !isEmpty(tradeLicense) && !buyer?.government) return BUYER_TYPES.COMPANY;
    return BUYER_TYPES.UAE_RESIDENT;
  };

  const transformDetails = (buyer, buyerType) => {
    if (isEmpty(buyer)) return {};
    switch (buyerType) {
      case BUYER_TYPES.UAE_RESIDENT:
        return {
          userId: buyer?.userId,
          eid: buyer?.eid,
          nameEn: buyer?.nameEn || buyer?.name,
          nameAr: buyer?.nameAr,
          birthDate: buyer?.birthDate,
          passportIssueDate: buyer?.passportIssueDate,
          passportExpiryDate: buyer?.passportExpiryDate,
          nationalityEn: buyer?.nationalityEn || buyer?.nationalityName,
          nationalityAr: buyer?.nationalityAr || buyer?.nationalityNameAr,
          phoneNumber: buyer?.phoneNumber || buyer?.phoneNo,
          email: buyer?.email,
        };
      case BUYER_TYPES.COMPANY:
        return {
          companyId: buyer?.companyId,
          tradeLicense: buyer?.tradeLicenseNumber || buyer?.licenseNumber,
          nameEn: buyer?.name || buyer?.companyNameEn,
          nameAr: buyer?.nameAr || buyer?.companyNameAr,
          phoneNumber: buyer?.mobileNumber || buyer?.phoneNo,
          email: buyer?.email || buyer?.companyEmail,
        };

      default:
        return {};
    }
  };

  const getFiltersInitialState = keysObj => {
    if (isEmpty(keysObj)) return {};
    return Object.values(keysObj)?.reduce((result, key) => ({ ...result, [key]: null }), {});
  };

  const getBuyerDocuments = (buyer, buyerType, documents) => {
    return documents?.filter(doc => {
      switch (buyerType) {
        case BUYER_TYPES.UAE_RESIDENT:
          return (
            BUYER_DOCUMENTS_ATTRIBUTES[buyerType].find(
              docAttributes => docAttributes?.name === doc?.type && doc?.userId === buyer?.userId,
            ) !== undefined
          );
        case BUYER_TYPES.COMPANY:
        case BUYER_TYPES.GOVERNMENT:
          return (
            BUYER_DOCUMENTS_ATTRIBUTES[buyerType].find(
              docAttributes => docAttributes?.name === doc?.type && doc?.companyId === buyer?.companyId,
            ) !== undefined
          );

        default:
          return null;
      }
    });
  };

  const getBuyerRepresentativeDocuments = (buyer, buyerType, documents) => {
    return documents?.filter(doc => {
      switch (buyerType) {
        case BUYER_TYPES.UAE_RESIDENT:
          return (
            BUYER_REPRESENTATIVE_DOCS_ATTRIBUTES.find(
              docAttributes => docAttributes?.name === doc?.type && doc?.userId === buyer?.userId,
            ) !== undefined
          );
        case BUYER_TYPES.COMPANY:
        case BUYER_TYPES.GOVERNMENT:
          return (
            BUYER_REPRESENTATIVE_DOCS_ATTRIBUTES.find(
              docAttributes => docAttributes?.name === doc?.type && doc?.companyId === buyer?.companyId,
            ) !== undefined
          );

        default:
          return null;
      }
    });
  };

  return {
    transformDetails,
    getBuyerType,
    getFiltersInitialState,
    getBuyerDocuments,
    getBuyerRepresentativeDocuments,
  };
}

export default useBuyerDetailsActions;
